import React from 'react';

type Props = {
  width?: number;
  height?: number;
  fill?: string;
  color?: string;
  onClick?: () => void;
};

const DocumentIcon = ({
  width = 16,
  height = 18,
  fill = 'none',
  color = '#202A2D',
  onClick,
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      cursor={'pointer'}
      onClick={onClick}
      viewBox='0 0 16 18'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.47059 7.35288V2.82347C3.47059 2.14124 4.02365 1.58818 4.70588 1.58818C5.38812 1.58818 5.94118 2.14124 5.94118 2.82347V7.35288C5.94118 8.71735 4.83506 9.82347 3.47059 9.82347C2.10612 9.82347 1 8.71735 1 7.35288V4.05877M8.82353 0.764648H11.0471C12.4307 0.764648 13.1225 0.764648 13.651 1.03393C14.1159 1.27079 14.4939 1.64874 14.7307 2.11361C15 2.6421 15 3.33393 15 4.71759V13.2823C15 14.666 15 15.3578 14.7307 15.8863C14.4939 16.3511 14.1159 16.7291 13.651 16.966C13.1225 17.2352 12.4307 17.2352 11.0471 17.2352H5.77647C4.39281 17.2352 3.70098 17.2352 3.17249 16.966C2.70762 16.7291 2.32967 16.3511 2.09281 15.8863C1.82353 15.3578 1.82353 14.666 1.82353 13.2823V12.7058'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default DocumentIcon;
